module.exports = __webpack_public_path__ + "img/par_15.92944286.jpg";